export const selectEvent = ({ event }) => event;
